import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../hospital.css';
import '../../assets/css/mainstyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CTab,
    CTabContent,
    CTabList,
    CTabPanel,
    CTabs,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CForm,
    CFormLabel,
    CFormInput,
    CAlert
} from '@coreui/react'
import { FaRedoAlt, FaExchangeAlt, FaFilter, FaSearch, FaDownload, FaFolderOpen, FaEllipsisV, FaEdit, FaSave, FaPalette } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsArrowUpLeft, BsArrowDownUp } from 'react-icons/bs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../service/caller';
import Adminprofil from '../../assets/images/adminprofil.png';
import { getUserIdFromToken } from '../../utils/authUtils';

// Import color picker component
import { ChromePicker } from 'react-color';

const Genaralconfig = () => {
    const [UserData, setUserData] = useState([]);
    const [hospitals, setHospitals] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(Adminprofil);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [saveError, setSaveError] = useState(null);
    const [isLogoUploading, setIsLogoUploading] = useState(false);
    const [showColorPicker, setShowColorPicker] = useState(false);

    // System settings for penalties and theme
    const [systemSettings, setSystemSettings] = useState({
        cancellationPenaltyPercentage: 30, // Default value, will be fetched from settings
        minimumCancellationHours: 48, // Default value, will be fetched from settings
        modificationPenaltyPercentage: 15, // Default value, will be fetched from settings
        minimumModificationHours: 24, // Default value, will be fetched from settings
        primaryColor: '#007bff' // Default primary color
    });

    // Set hospital logo from user data
    useEffect(() => {
        if (UserData?.hospital_id?.length > 0) {
            const hospitalLogo = UserData.hospital_id[0].picture;
            if (hospitalLogo) {
                setPreviewImage(hospitalLogo);
            }
        }
    }, [UserData]);

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch user data");
            }
        };

        const fetchSystemSettings = async () => {
            try {
                const response = await api.get('/clinic/system-settings');
                if (response.data) {
                    setSystemSettings({
                        cancellationPenaltyPercentage: response.data.cancellationPenaltyPercentage || 30,
                        minimumCancellationHours: response.data.minimumCancellationHours || 48,
                        modificationPenaltyPercentage: response.data.modificationPenaltyPercentage || 15,
                        minimumModificationHours: response.data.minimumModificationHours || 24,
                        primaryColor: response.data.primaryColor || '#007bff'
                    });
                }
                setLoading(false);
            } catch (error) {
                console.error('Error fetching system settings:', error);
                setError('Failed to fetch system settings');
                setLoading(false);
            }
        };

        fetchLoggedUserData();
        fetchSystemSettings();
    }, []);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setPreviewImage(URL.createObjectURL(file)); // Affichage de l'aperçu
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            toast.warning("Please select an image first.");
            return;
        }

        setIsLogoUploading(true);
        const formData = new FormData();
        formData.append("logo", selectedFile);
        formData.append("hospitalId", UserData.main_hospital_id); // Ajout de l'ID de l'hôpital

        try {
            const response = await api.post("/api/addhospitallogo", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            toast.success("Logo updated successfully!");
            
            // Wait 1 second before refreshing the page to allow toast to be seen
            setTimeout(() => {
                window.location.reload();
            }, 1000);
            
        } catch (error) {
            console.error("Error:", error);
            toast.error(error.response?.data?.message || "Failed to upload logo.");
        } finally {
            setIsLogoUploading(false);
        }
    };

    // Handle penalty settings changes
    const handleSettingsChange = (e) => {
        const { name, value } = e.target;
        setSystemSettings(prev => ({
            ...prev,
            [name]: Number(value)
        }));
    };

    // Handle color selection change
    const handleColorChange = (color) => {
        setSystemSettings(prev => ({
            ...prev,
            primaryColor: color.hex
        }));
    };

    // Helper function to determine if color is light (for text contrast)
    const isLightColor = (color) => {
        // Convert hex to RGB
        const hex = color.replace('#', '');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);

        // Calculate brightness
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 128;
    };

    // Save penalty settings
    const saveSystemSettings = async () => {
        setIsSaving(true);
        setSaveSuccess(false);
        setSaveError(null);

        try {
            const response = await api.post('/clinic/system-settings', systemSettings);

            if (response.status === 200) {
                setSaveSuccess(true);
                toast.success('System settings updated successfully');
            } else {
                setSaveError('Failed to update system settings');
                toast.error('Failed to update system settings');
            }
        } catch (error) {
            console.error('Error updating system settings:', error);
            setSaveError(error.response?.data?.message || 'Failed to update system settings');
            toast.error('Error: ' + (error.response?.data?.message || 'Failed to update system settings'));
        } finally {
            setIsSaving(false);
        }
    };

    // Example preview component for the selected color
    const ColorPreview = () => {
        return (
            <div className="d-flex flex-column mb-4">
                <h6 className="mb-3">Color Preview</h6>
                <div className="d-flex flex-column gap-2">
                    <div
                        className="p-3 rounded"
                        style={{
                            backgroundColor: systemSettings.primaryColor,
                            color: isLightColor(systemSettings.primaryColor) ? '#000' : '#fff',
                            border: '1px solid #dee2e6'
                        }}
                    >
                        Primary Color Background
                    </div>
                    <CButton
                        style={{
                            backgroundColor: systemSettings.primaryColor,
                            borderColor: systemSettings.primaryColor,
                        }}
                    >
                        Button with Primary Color
                    </CButton>
                    <div className="p-2 border rounded">
                        <span style={{ color: systemSettings.primaryColor }}>
                            Text with Primary Color
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="dashboard-header" >
            <ToastContainer />
            <CHeader position="sticky" style={{ backgroundColor: '#DFEAF5' }}>
                <CContainer fluid className="d-flex align-items-center">
                    <div className='row w-100'>
                        {/* Barre de recherche */}
                        <div className="pagetittle col">
                            <h4><b>General Config</b></h4>
                        </div>
                        {/* Profil utilisateur */}

                        <div className=' d-flex col justify-content-end'>
                            <CHeaderNav>
                                <CNavItem>
                                    <CNavLink href="#" className="d-flex ms-auto">
                                        <img src={UserData?.picture || Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                                        <div>
                                            <span className="ms-2" style={{ color: 'black' }}>{UserData.firstname} {UserData.lastname}</span>
                                            <p className="ms-2" style={{ color: 'black' }}>{UserData.role?.name}</p>
                                        </div>
                                    </CNavLink>
                                </CNavItem>
                            </CHeaderNav>
                        </div>
                    </div>
                </CContainer>
            </CHeader>

            <section>
                <CRow>
                    <CCol xs={12}>
                        <CCard className="card mb-4 p-4">
                            <CCardBody>
                                <div className='d-flex flex-column'>
                                    <h5 className="card-title mb-4">Hospital Logo</h5>
                                    <div>
                                        <div className="form-group newregistermodal">
                                            <div className="profile-photo d-flex">
                                                <div className="photo-container">
                                                    <img src={previewImage} alt="Profile" className="profile-image" />
                                                </div>
                                                <div className='photoedit'>
                                                    <label htmlFor="file-input">
                                                        <FaEdit />
                                                    </label>
                                                    <input type="file" id="file-input" accept="image/*" onChange={handleFileChange} />
                                                    <p className='ms-2'>Upload profile photo (jpg, png, jpeg)</p>
                                                </div>
                                            </div>
                                        </div>
                                        <CButton 
                                            onClick={handleUpload} 
                                            className="btn btn-primary mt-2"
                                            disabled={isLogoUploading || !selectedFile}
                                        >
                                            {isLogoUploading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Uploading...
                                                </>
                                            ) : 'Upload Logo'}
                                        </CButton>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>

                {/* Appointment Penalty Settings */}
                {UserData?.role?.name === "medtinz_client_master" && (
                <CRow>
                    <CCol xs={12}>
                        <CCard className="card mb-4 p-4">
                            <CCardBody>
                                <h5 className="card-title mb-4">Appointment Penalty Settings</h5>

                                {loading ? (
                                    <div className="d-flex justify-content-center">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : error ? (
                                    <CAlert color="danger">{error}</CAlert>
                                ) : (
                                    <CForm>
                                        <CRow className="mb-4">
                                            <CCol md={6}>
                                                <h6 className="mb-3">Cancellation Policy</h6>
                                                <div className="mb-3">
                                                    <CFormLabel htmlFor="cancellationPenaltyPercentage">
                                                        Cancellation Penalty Percentage (%)
                                                    </CFormLabel>
                                                    <CFormInput
                                                        type="number"
                                                        id="cancellationPenaltyPercentage"
                                                        name="cancellationPenaltyPercentage"
                                                        value={systemSettings.cancellationPenaltyPercentage}
                                                        onChange={handleSettingsChange}
                                                        min="0"
                                                        max="100"
                                                    />
                                                    <small className="text-muted">
                                                        Percentage of the appointment cost that will be charged as a penalty for cancellations.
                                                    </small>
                                                </div>
                                                <div className="mb-3">
                                                    <CFormLabel htmlFor="minimumCancellationHours">
                                                        Penalty-Free Cancellation Period (hours)
                                                    </CFormLabel>
                                                    <CFormInput
                                                        type="number"
                                                        id="minimumCancellationHours"
                                                        name="minimumCancellationHours"
                                                        value={systemSettings.minimumCancellationHours}
                                                        onChange={handleSettingsChange}
                                                        min="0"
                                                    />
                                                    <small className="text-muted">
                                                        Minimum hours before the appointment when a patient can cancel without penalty.
                                                    </small>
                                                </div>
                                            </CCol>

                                            <CCol md={6}>
                                                <h6 className="mb-3">Modification Policy</h6>
                                                <div className="mb-3">
                                                    <CFormLabel htmlFor="modificationPenaltyPercentage">
                                                        Modification Penalty Percentage (%)
                                                    </CFormLabel>
                                                    <CFormInput
                                                        type="number"
                                                        id="modificationPenaltyPercentage"
                                                        name="modificationPenaltyPercentage"
                                                        value={systemSettings.modificationPenaltyPercentage}
                                                        onChange={handleSettingsChange}
                                                        min="0"
                                                        max="100"
                                                    />
                                                    <small className="text-muted">
                                                        Percentage of the appointment cost that will be charged as a penalty for late modifications.
                                                    </small>
                                                </div>
                                                <div className="mb-3">
                                                    <CFormLabel htmlFor="minimumModificationHours">
                                                        Penalty-Free Modification Period (hours)
                                                    </CFormLabel>
                                                    <CFormInput
                                                        type="number"
                                                        id="minimumModificationHours"
                                                        name="minimumModificationHours"
                                                        value={systemSettings.minimumModificationHours}
                                                        onChange={handleSettingsChange}
                                                        min="0"
                                                    />
                                                    <small className="text-muted">
                                                        Minimum hours before the appointment when a patient can modify without penalty.
                                                    </small>
                                                </div>
                                            </CCol>
                                        </CRow>

                                        {/* Theme Color Settings */}
                                        <CRow className="mb-4">
                                            <CCol md={12}>
                                                <h6 className="mb-3">
                                                    <FaPalette className="me-2" /> Theme Color Settings
                                                </h6>
                                                <CRow>
                                                    <CCol md={6}>
                                                        <div className="mb-3">
                                                            <CFormLabel htmlFor="primaryColor">
                                                                Primary Theme Color
                                                            </CFormLabel>
                                                            <div className="d-flex">
                                                                <div 
                                                                    className="color-preview-square me-3" 
                                                                    style={{
                                                                        backgroundColor: systemSettings.primaryColor,
                                                                        width: '40px',
                                                                        height: '40px',
                                                                        border: '1px solid #dee2e6',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    onClick={() => setShowColorPicker(!showColorPicker)}
                                                                />
                                                                <CFormInput
                                                                    type="text"
                                                                    id="primaryColor"
                                                                    name="primaryColor"
                                                                    value={systemSettings.primaryColor}
                                                                    readOnly
                                                                    className="color-text-input"
                                                                    style={{ width: '150px' }}
                                                                />
                                                                <CButton 
                                                                    className="ms-2" 
                                                                    onClick={() => setShowColorPicker(!showColorPicker)}
                                                                    style={{
                                                                        backgroundColor: showColorPicker ? '#6c757d' : systemSettings.primaryColor,
                                                                        borderColor: showColorPicker ? '#6c757d' : systemSettings.primaryColor,
                                                                    }}
                                                                >
                                                                    {showColorPicker ? 'Close' : 'Pick Color'}
                                                                </CButton>
                                                            </div>
                                                            {showColorPicker && (
                                                                <div className="mt-2 position-relative" style={{ zIndex: 100 }}>
                                                                    <div style={{ position: 'absolute' }}>
                                                                        <ChromePicker 
                                                                            color={systemSettings.primaryColor}
                                                                            onChange={handleColorChange}
                                                                            disableAlpha={true}
                                                                            className="shadow"
                                                                        />
                                                                        <div 
                                                                            style={{
                                                                                position: 'fixed',
                                                                                top: '0',
                                                                                right: '0',
                                                                                bottom: '0',
                                                                                left: '0',
                                                                                zIndex: -1
                                                                            }}
                                                                            onClick={() => setShowColorPicker(false)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <small className="text-muted d-block mt-2">
                                                                Choose the primary color for the hospital interface. This will affect buttons, links, and highlight elements.
                                                            </small>
                                                        </div>
                                                    </CCol>
                                                    <CCol md={6}>
                                                        <ColorPreview />
                                                    </CCol>
                                                </CRow>
                                            </CCol>
                                        </CRow>

                                        {saveSuccess && (
                                            <CAlert color="success" className="mb-3">
                                                Settings saved successfully!
                                            </CAlert>
                                        )}

                                        {saveError && (
                                            <CAlert color="danger" className="mb-3">
                                                {saveError}
                                            </CAlert>
                                        )}

                                        <div className="d-flex justify-content-end">
                                            <CButton
                                                color="primary"
                                                onClick={saveSystemSettings}
                                                disabled={isSaving}
                                                style={{
                                                    backgroundColor: systemSettings.primaryColor,
                                                    borderColor: systemSettings.primaryColor
                                                }}
                                            >
                                                {isSaving ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Saving...
                                                    </>
                                                ) : (
                                                    <>
                                                        <FaSave className="me-2" /> Save Settings
                                                    </>
                                                )}
                                            </CButton>
                                        </div>
                                    </CForm>
                                )}
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
                )}
            </section>
        </div>
    );
};

export default Genaralconfig;